import { useEffect, useState } from "react";

const ADVANCED_KEY = "atelie_onboarding_v2_completed";

export function useOnboardingHint(sectionKey: string) {
  const storageKey = `atelie_onboarding_hint_${sectionKey}`;
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const updateFromStorage = () => {
      const advancedCompleted = window.localStorage.getItem(ADVANCED_KEY) === "true";
      if (advancedCompleted) {
        setShowHint(false);
        return;
      }

      const dismissed = window.localStorage.getItem(storageKey) === "hidden";
      setShowHint(!dismissed);
    };

    updateFromStorage();

    const handleStorage = (event: StorageEvent) => {
      if (event.key === storageKey || event.key === ADVANCED_KEY) {
        updateFromStorage();
      }
    };

    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, [storageKey]);

  const hideHint = () => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(storageKey, "hidden");
    }
    setShowHint(false);
  };

  const resetHint = () => {
    if (typeof window !== "undefined") {
      window.localStorage.removeItem(storageKey);
    }
    setShowHint(true);
  };

  return { showHint, hideHint, resetHint };
}
